<template>
    <div id="PrescriptionFilter" class="pb-10">
        <v-expansion-panels flat>
            <v-expansion-panel>
                <v-expansion-panel-header class="pa-0" hide-actions>
                    <template v-slot:default="{ open }">
                        <div class="d-flex align-center">
                            <div class="text-subtitle-1 font-weight-bold gray--text">Фильтр</div>
                            <v-icon color="gray" v-if="open">arrow_drop_up</v-icon>
                            <v-icon color="gray" v-else>arrow_drop_down</v-icon>
                        </div>
                    </template>
                </v-expansion-panel-header>

                <v-expansion-panel-content class="v-row">
                    <!-- Статусы -->
                    <div class="px-3">
                        <div class="mb-2">Статус предписания:</div>
                        <v-row dense class="status-row">
                            <v-col v-for="opt in statusOptions" :key="opt.value" cols="12" class="status-col">
                                <v-checkbox v-model="statuses" :label="opt.label" :value="opt.value" color="gray" hide-details dense />
                            </v-col>
                        </v-row>
                    </div>

                    <v-row class="px-3">
                        <v-col cols="12" lg="6">
                            <v-autocomplete
                                label="№ договора"
                                color="gray"
                                outlined
                                dense
                                clearable
                                :items="contracts"
                                item-text="contract_number"
                                item-value="contract_rid"
                                v-model="filter.contract_rid"
                                no-data-text="Нет договоров"
                            />
                        </v-col>

                        <v-col cols="12" lg="6">
                            <v-autocomplete
                                label="Наименование объекта"
                                color="gray"
                                outlined
                                dense
                                clearable
                                :items="objects"
                                item-text="object_name"
                                item-value="object_name"
                                v-model="filter.object_name"
                                no-data-text="Нет объектов"
                            />
                        </v-col>

                        <!-- Период  -->
                        <v-col cols="auto" class="flex-grow-0">
                            <v-autocomplete
                                label="Период"
                                color="gray"
                                outlined
                                dense
                                clearable
                                :items="periods"
                                item-text="name"
                                item-value="rid"
                                v-model="filter.period_rid"
                                no-data-text="Нет периодов"
                                style="max-width: 180px; width: 100%"
                            />
                        </v-col>

                        <!--номер предписния  -->
                        <v-col cols="12" lg="3">
                            <v-text-field
                                v-model="filter.prescription_number"
                                label="Номер предписания"
                                color="gray"
                                outlined
                                dense
                                clearable
                                type="number"
                                min="0"
                                @input="onPrescriptionNumberInput"
                            />
                        </v-col>
                    </v-row>

                    <div class="px-3 pb-4">
                        <v-btn color="white" outlined @click="resetFilter" class="mr-4 gray--text">Сбросить</v-btn>
                        <v-btn color="gray" class="white--text" @click="applyFilter">Применить</v-btn>
                    </div>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>

<script>
export default {
    name: 'PrescriptionFilter',
    props: {
        filterModel: { type: Object, required: true },
        contracts: { type: Array, default: () => [] },
        objects: { type: Array, default: () => [] },
        periods: { type: Array, default: () => [] },
        contractsLoading: { type: Boolean, default: false }
    },
    mounted() {},
    emits: ['update:filterModel', 'applyFilter', 'resetFilter'],
    data() {
        return {
            statusOptions: [
                { label: 'Выдано', value: 'issued' },
                { label: 'Возвращено', value: 'returned' },
                { label: 'Проверено', value: 'checked' },
                { label: 'Выдан акт готовности', value: 'issued_act' },
                { label: 'Исполнено', value: 'completed' },
                { label: 'Закрыто', value: 'closed' }
            ],
            yearMenu: false,
            minYear: 2015,
            maxYear: new Date().getFullYear() + 1
        };
    },
    computed: {
        filter: {
            get() {
                return this.filterModel;
            },
            set(value) {
                this.$emit('update:filterModel', value);
            }
        },

        statuses: {
            get() {
                return Array.isArray(this.filter.statuses) ? this.filter.statuses : [];
            },
            set(val) {
                const next = { ...this.filter, statuses: val };
                this.$emit('update:filterModel', next);
            }
        },
        yearDisplay() {
            return this.filter && this.filter.year ? String(this.filter.year) : '';
        },
        years() {
            const from = Number(this.minYear);
            const to = Number(this.maxYear);

            const arr = [];
            for (let y = to; y >= from; y--) arr.push(y);
            return arr;
        }
    },
    watch: {
        yearMenu(val) {
            if (val) {
                this.activePicker = 'YEAR';

                this.pickerDate = this.filter.year ? String(this.filter.year) : String(new Date().getFullYear());
            }
        },

        activePicker(val, old) {
            if (old === 'YEAR' && val === 'MONTH') {
                const y = parseInt((this.pickerDate || '').slice(0, 4), 10);
                const next = { ...this.filter, year: Number.isFinite(y) ? y : null };
                this.$emit('update:filterModel', next);

                this.$nextTick(() => {
                    this.yearMenu = false;
                    this.activePicker = 'YEAR';
                });
            }
        }
    },
    methods: {
        applyFilter() {
            this.$emit('applyFilter');
        },
        resetFilter() {
            this.$emit('resetFilter');
        },
        pickYear(y) {
            const next = { ...this.filter, year: y };
            this.$emit('update:filterModel', next);
            this.$nextTick(() => (this.yearMenu = false));
        },
        clearYear() {
            const next = { ...this.filter, year: null };
            this.$emit('update:filterModel', next);
        },
        onPrescriptionNumberInput(value) {
            const numericValue = String(value || '').replace(/\D/g, '');

            const next = {
                ...this.filter,
                prescription_number: numericValue
            };

            this.$emit('update:filterModel', next);
        }
    }
};
</script>

<style>
#PrescriptionFilter .v-expansion-panel-content__wrap {
    padding: 0;
}
.status-row {
    flex-wrap: nowrap;
}

@media (min-width: 960px) {
    #PrescriptionFilter .status-col {
        flex: 1 0 0;
        max-width: none;
    }
}
</style>
